import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

import ButtonGroup from '../../Buttons/ButtonGroup';
import Image from '../../Image';
import PageText from '../../Text/PageText';
import Spacer from '../../Spacer';

import AbelIcon from '../../../Assets/Icons/Abel_HeaderIcon.png';
import AdditionalActivity from '../../../Assets/Icons/AdditionalActivity.png';
import Checkmark from '../../../Assets/Icons/Checkmark_Selected.png';
import Endurance from '../../../Assets/Icons/Endurance.png';
import Female from '../../../Assets/Icons/Female.png';
import Male from '../../../Assets/Icons/Male.png';
import Strength from '../../../Assets/Icons/Strength.png';

const MultiSelect = styled.span`
    ${
        props => props.Selected ?
        `
            background-image: url(${Checkmark});
            background-position: center;
            background-repeat: no-repeat;
            background-size: 20px;
        `
    :
        `
            background-color: var(--white);
            border: 2px solid var(--gray-light);
        `
    };
    border-radius: 10px;
    height: 20px;
    left: 15px;
    position: absolute;
    top: 15px;
    width: 20px;

    @media(hover:hover) {
        :hover {
            background-image: url(${Checkmark});
            background-position: center;
            background-repeat: no-repeat;
            background-size: 20px;
            border: none;
            cursor: pointer;
        }
    }
`;

const StyledProfilePhoto = styled(Image)`
    height: 25px;
    left: 15px;
    position: absolute;
    top: 15px;
    width: 25px;

    ${props => !props.IsAbel && 'border-radius: 50%;'}
    overflow: hidden;
`;

const TemplateContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;

    ${
        props => props.Selected && 1 === 2 ?
        `
            border: 5px solid var(--blue-abel);
            border-radius: 10px;
            padding: 10px;
        `
    :
        null
    }

    > div:first-of-type {
        align-items: center;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
    }
`;

const TemplateDetailContainer = styled.div`
    background-color: var(--white-concrete-light);
    border: 5px solid var(--white-concrete-light);
    border-radius: 20px;
    padding: 15px 38px;

    @media(hover:hover) {
        :hover {
            // background-color: var(--white-concrete-hover);
            ${props => !!props.onClick && 'cursor: pointer;'}
        }
    }

    ${
        props => props.Selected &&
        `
            background-color: rgba(26, 151, 255, 0.35);
            border: 5px solid var(--blue-abel);
            border-radius: 20px;

            @media(hover:hover) {
                :hover {
                    background-color: rgba(26, 151, 255, 0.35);
                }
            }
        `
    }
`;

// ^^ padding: ${props => props.IsMultiSelect ? '15px 38px' : '15px'};

const TemplateIcon = styled.img`
    height: 20px;
    right: 15px;
    position: absolute;
    top: 15px;
    width: 20px;
`;

const TemplateNameContainer = styled.div``;

const StyledTemplateName = styled(PageText)`
    text-transform: uppercase;
`;

class WorkoutTemplateListItem extends React.Component {
    onMultiSelect = (event, Item, MultiSelectIndex) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();

        this.props.OnMultiSelect(Item, MultiSelectIndex);
    }

    onUpdateSharedToCoachStatus = ({ event, ContentId, NewStatus }) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();

        this.props.OnUpdateSharedToCoachStatus({ ContentId, NewStatus, PersonalResponse: 1 });
    }

    renderMultiSelect = () => {
        var { Item, MultiSelectItemIds, OnMultiSelect } = this.props;

        var { TemplateId } = Item;

        var MultiSelectIndex = MultiSelectItemIds.indexOf(+TemplateId);

        return <MultiSelect onClick={() => OnMultiSelect(Item, MultiSelectIndex)} Selected={MultiSelectIndex !== -1} />;
    }

    renderMultiSelectButton = () => {
        var { t } = this.props;
        var { Item, MultiSelectItemIds } = this.props;

        var { TemplateId } = Item;

        var MultiSelectIndex = MultiSelectItemIds.indexOf(+TemplateId);

        return (
            <>
                <Spacer Size="extra-small" />

                <ButtonGroup
                    Buttons={[{ BackgroundColor: 'white', BackgroundColorHover: 'blue-abel', Border: 'none', Color: 'black', ColorHover: 'white', ColorSelected: 'white', FontFamily: 'semibold', FontSize: 'medium-1', OnClick: e => this.onMultiSelect(e, Item, MultiSelectIndex), Selected: MultiSelectIndex !== -1, Size: 'small', Title: t(MultiSelectIndex !== -1 ? 'WorkoutPlanSettings_selected' : 'select_with_first_char_uppercase') }]}
                    ContainerWidth="100%"
                />
            </>
        );
    }

    renderNonSelectable = () => {
        var { t } = this.props;
        var { className, Item, ViewTemplate } = this.props;

        var { TemplateId, TemplateName, WorkoutType } = Item;

        return (
            <TemplateContainer id={`itemid-${TemplateId}`} className={className}>
                {this.renderUserPhoto()}

                {this.renderWorkoutType(WorkoutType)}

                <TemplateDetailContainer className="TemplateDetailContainer" onClick={!!ViewTemplate ? () => ViewTemplate(Item) : () => null}>
                    <TemplateNameContainer className="TemplateNameContainer">
                        <StyledTemplateName FontFamily="semibold" FontSize="small" NoMargin Text={TemplateName} TextAlign="center"/>
                    </TemplateNameContainer>

                    <Spacer Size="extra-small" />

                    <ButtonGroup
                        Buttons={[
                            {
                                BackgroundColorHover: 'blue-abel',
                                ColorHover: 'white',
                                Disabled: true,
                                FontFamily: 'medium',
                                FontSize: 'small',
                                Size: 'small',
                                Title: t('select_with_first_char_uppercase')
                            }
                        ]}
                        ContainerWidth="100%"
                    />
                </TemplateDetailContainer>
            </TemplateContainer>
        );
    }

    renderUserPhoto = () => {
        var { DisplayName, Sex, UserId, UserPhoto } = this.props.Item;

        var SexImage = Sex === 'Male' ? Male : Female;

        if (UserId === 16) UserPhoto = AbelIcon;

        return <StyledProfilePhoto Alt={DisplayName} ImageSrc={UserPhoto} IsAbel={UserId === 16} NoImage={SexImage} NoParent />;
    }

    renderWorkoutType = WorkoutType => {
        var IconSrc = WorkoutType === 1 ? Strength : WorkoutType === 2 ? Endurance : AdditionalActivity;

        return <TemplateIcon src={IconSrc} alt="Workout Type" />
    }
    
    render() {
        var { t } = this.props;
        var { className, AssignToClients, HideSelect, MultiSelectItemIds, IsMultiSelect, Item, OnAssignToClients, SelectTemplate, SelectedItemIds, ViewTemplate } = this.props;

        var { RelationshipType, SharedStatus, TemplateId, TemplateName, WorkoutType } = Item;

        // If Select Button is Showing, Hide Abel Templates and Pending SharedTo as they can't do anything in the multi-select options
            // if ((RelationshipType === 'Abel' || (RelationshipType === 'SharedTo' && SharedStatus === 2)) && !HideSelect && IsMultiSelect) return this.renderNonSelectable();

        // If RelationshipType === 'SharedTo' && SharedStatus === 2, Then Show Only Accept / Pending Buttons
            if ((RelationshipType === 'SharedTo' && SharedStatus === 2)) {
                return (
                    <TemplateContainer id={`itemid-${TemplateId}`} className={className}>
                        {this.renderUserPhoto()}

                        {this.renderWorkoutType(WorkoutType)}

                        <TemplateDetailContainer className="TemplateDetailContainer" onClick={!!ViewTemplate ? () => ViewTemplate(Item) : () => null}>
                            <TemplateNameContainer className="TemplateNameContainer">
                                <StyledTemplateName FontFamily="semibold" FontSize="small" NoMargin Text={TemplateName} TextAlign="center"/>
                            </TemplateNameContainer>

                            <Spacer Size="extra-small" />

                            <ButtonGroup
                                Buttons={[
                                    { BackgroundColor: 'red-bittersweet', BackgroundColorHover: 'red-bittersweet-hover', Border: 'none', Color: 'white', ColorHover: 'white', OnClick: event => this.onUpdateSharedToCoachStatus({ event, ContentId: TemplateId, NewStatus: 'reject' }), Size: 'small', Title: t('reject') },
                                    { BackgroundColor: 'blue-abel', BackgroundColorHover: 'blue-abel-hover', Border: 'none', Color: 'white', ColorHover: 'white', OnClick: event => this.onUpdateSharedToCoachStatus({ event, ContentId: TemplateId, NewStatus: 'accept' }), Size: 'small', Title: t('accept') }
                                ]}
                                // ButtonWidth="fit-content"
                                NotTouching
                                OwnRows
                            />
                            
                        </TemplateDetailContainer>
                    </TemplateContainer>
                );
            }

        var Selected = SelectedItemIds.indexOf(+TemplateId) > -1 || MultiSelectItemIds.indexOf(+TemplateId) > -1;

        return (
            <TemplateContainer id={`itemid-${TemplateId}`} className={className} Selected={Selected}>
                {/* {IsMultiSelect && this.renderMultiSelect()} */}

                {this.renderUserPhoto()}

                {this.renderWorkoutType(WorkoutType)}

                <TemplateDetailContainer className="TemplateDetailContainer" IsMultiSelect={IsMultiSelect} onClick={!!ViewTemplate ? () => ViewTemplate(Item) : () => null} Selected={Selected}>
                    <TemplateNameContainer className="TemplateNameContainer">
                        <StyledTemplateName FontFamily="semibold" FontSize="small" NoMargin Text={TemplateName} TextAlign="center"/>
                    </TemplateNameContainer>
                    {
                        AssignToClients && HideSelect &&
                        <>
                            <Spacer Size="extra-small" />

                            <ButtonGroup
                                Buttons={[{ BackgroundColor: 'white', BackgroundColorHover: 'blue-abel', Border: 'none', Color: 'black', ColorHover: 'white', ColorSelected: 'white', FontFamily: 'semibold', FontSize: 'medium-1', OnClick: e => OnAssignToClients(e, Item), Size: 'small', Title: t('assign_to_clients') }]}
                                ContainerWidth="100%"
                            />
                        </>
                    }

                    {IsMultiSelect && !HideSelect && this.renderMultiSelectButton()}
                </TemplateDetailContainer>

                {
                    !HideSelect && !IsMultiSelect &&
                    <>
                        <Spacer Size="extra-small" />
                        
                        <ButtonGroup
                            Buttons={[{ BackgroundColorHover: 'blue-abel', BackgroundColorSelected: 'blue-abel', ColorHover: 'white', ColorSelected: 'white', FontFamily: 'medium', FontSize: 'small', OnClick: () => SelectTemplate(Item), Selected, Size: 'small', Title: t(Selected ? 'WorkoutPlanSettings_selected' : 'select_with_first_char_uppercase') }]}
                            ContainerWidth="100%"
                        />
                    </>
                }
            </TemplateContainer>
        );
    }
}

WorkoutTemplateListItem.propTypes = {
    AssignToClients: PropTypes.bool,
    HideSelect: PropTypes.bool,
    IsMultiSelect: PropTypes.bool,
    Item: PropTypes.object,
    OnAssignToClients: PropTypes.func,
    OnMultiSelect: PropTypes.func,
    MultiSelectItemIds: PropTypes.array,
    SelectTemplate: PropTypes.func,
    SelectedItemIds: PropTypes.array,
    ViewTemplate: PropTypes.func
}

WorkoutTemplateListItem.defaultProps = {
    MultiSelectItemIds: [],
    SelectedItemIds: []
}

export default withTranslation()(WorkoutTemplateListItem);